(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-slider"] && !Shopify.designMode) return;
  try {
    
  $(function(){
    $('.home-carousel').slick({
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 7000,
      dots: true
    });
  });

  } catch(e) { console.error(e); }
})();
})();
